import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import Textfield from "../../shared/textfield";
import { pcolor } from "../../../style2";

export default function SafeguardingIssues(props) {

  const [disabledField, setDisabledField] = useState(true);
  const [anySafeGuardingIssue, setAnySafeGuardingIssue] = useState(props.profile.childSafeGuarding?.notApplicable === true ? "yes" : null);
  const [doNotWishToDisclose, setDoNotWishToDisclose] = useState(true);
  const [safeGuardingTextDisabled, setSafeGuardingTextDisabled] = useState(true);
  const [doNotWishToDiscloseDisabled, setDoNotWishToDiscloseDisabled] = useState(true);

  const handleDoNotWishToDisclose = (event) => {
    setDoNotWishToDisclose(event.target.checked);
    setSafeGuardingTextDisabled(event.target.checked);
  };

  const handleAnySafeGuardingIssue = (event) => {
    //console.log("event:", event.target.value);
    setAnySafeGuardingIssue(event.target.value);
    setDoNotWishToDiscloseDisabled(event.target.value === "no" ? true : false);
    setDoNotWishToDisclose(event.target.value !== "no" && false);
    if (!doNotWishToDisclose) {
      setSafeGuardingTextDisabled(event.target.value === "no" ? true : false);
    }
  };

  // const handleEdit = () => {
  //   setDisabledField(!disabledField);
  //   setDoNotWishToDisclose(!disabledField);
  //   setSafeGuardingTextDisabled(!disabledField);
  //   if (!disabledField) {
  //     // To save changes here
  //   }
  // };

  // const handleCancelEdit = () => {
  //   setDisabledField(true);
  // };

  const profile = props.profile;

  return (
    <Box ml={2} mr={2} mb={2}>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <FormControl>
            <FormLabel sx={{ color: pcolor }}>Any safeguarding issue?</FormLabel>
            <RadioGroup row value={anySafeGuardingIssue} onChange={handleAnySafeGuardingIssue}>
              <FormControlLabel value='yes' control={<Radio />} label='Yes' disabled={disabledField} />
              <FormControlLabel value='no' control={<Radio />} label='No' disabled={disabledField} />
            </RadioGroup>
          </FormControl>
        </Grid>
        {profile.childSafeGuarding?.doNotDisclose ?
          <Grid item xs={6} sm={6}>
            <FormControl>
              <FormLabel sx={{ color: pcolor }}>Do not wish to disclose</FormLabel>
              <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                <Checkbox
                  disabled={disabledField || doNotWishToDiscloseDisabled}
                  checked={profile.childSafeGuarding?.doNotDisclose}
                  onChange={handleDoNotWishToDisclose}
                  inputProps={{ "aria-label": "controlled" }}
                />
                <Typography>Yes</Typography>
              </Box>
            </FormControl>

          </Grid> : null}
        {profile.childSafeGuarding?.childUnderSocialServices && profile.childSafeGuarding?.childUnderSocialServices !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='Is the child under the care of social services?'
              value={profile.childSafeGuarding?.childUnderSocialServices}
              disabled={disabledField || safeGuardingTextDisabled}
              multiline
              rows={2}
            />
          </Grid> : null}

      </Grid>
    </Box>
  );
}
